//@vendors
const Immutable = require('immutable');
const get = require('lodash/object/get');
const ceil = require('lodash/math/ceil');
const find = require('lodash/collection/find');
const { handleActions, combineActions } = require('redux-actions');
// @core
const { formatText } = require('core/i18n').i18n;
//@actions
const { simpleActions } = require('../../actions/contractEasyLoanTypeC');
//@helpers
const { decimalsLength, parseSpanishNumberToFloat } = require('utilities/currencyHelper');
//@constant
const { PAYMENT_DAY_OTHER } = require('../../loansConstants/index').contractEasyLoan;
const {
    EURO_TEXT,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP } = require('constants/index');
const {
    payrollLoanJobs: {
        PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE,
    },
    payrollLoanJobTypeKeys: {
        OWN_ACCOUNT_DRAGO_OPTION_KEY
    },
    easyLoanErrorDocument: { NOM_VL, IRPF100, IRPF130, NEW_IRPF100_FILE, IRPF100_CLI, IRPF100_CLI_2, IRPF100_CLI_3, IRPF100_CLI_4, PEND_VAL, NO_VALIDO },
    easyLoanTypeUpload: {
        IRPF_FILE,
        IRPF130_FILE,
        IRPF100_FILE,
        IRPF100_CLI_FILE,
        IRPF100_CLI_FILE_2,
        IRPF100_CLI_FILE_3,
        IRPF100_CLI_FILE_4,
        EASY_LOAN_CERTIFICATE,
        FILE_FIRST_INDEX
    },
    easyLoanRecordStatus: { requestStatus: { ERROR_DOCUMENTACION } },
    MAX_UPLOAD_EXPENSES_COMPONENTS
} = require('../../loansConstants/index');

//@utilities
const {
    showWorkingTimeSection,
    getTranslatedDocumentName,
} = require('../../loansUtilities/loansHelper');

const setInitialState = () => Immutable.fromJS({
    steps: [
        { valid: false },
        { valid: false },
        { valid: false },
    ],
    twoSteps: [
        { valid: false },
        { valid: false },
    ],
    collectiveInformation: [{
        name: '',
        code: '',
        productDetail: {
            type: '',
            subType: '',
            standardCode: ''
        },
        installment: 0,
        tin: 0,
        tae: 0,
        totalAmount: 0
    }],
    showTypeC: false,
    visibleStep: WIZARD_FIRST_STEP,
    beforeStep: 0,
    isFetching: false,
    isFetchingInstallment: false,
    isFetchingMinInstallmentQuantity: false,
    isFetchingDocuments: !__CONTACT_CENTER__, // We don´t fetch documents in CC - the PDF viewer is hidden
    isFetchingZip: false,
    submitSuccessful: false,
    willCancel: false,
    error: false,
    fetchingTotalAmount: false,
    amountDefaultLimit: 0,
    maxAmount: 0,
    minAmount: 0,
    maxAmountError: false,
    minTae: 0,
    maxTae: 0,
    aniversaryStandard: '',
    aniversarySubtype: '',
    aniversaryType: '',
    currency: EURO_TEXT,
    showPurposeError: false,
    openingCommission: {},
    selectedAmount: 0,
    selectedPurpose: '',
    selectedPurposeDrago: '',
    selectedTerm: 0,
    standard: '',
    stepReady: false,
    totalAmount: 0,
    subtype: '',
    tae: 0,
    termDefaultLimit: 0,
    maxTerm: 0,
    minTerm: 0,
    notAvailable: false,
    tin: 0,
    type: '',
    installment: {
        amount: 0,
        currency: EURO_TEXT,
        decimalsLength: 0
    },
    outcome: {
        income: null,
        expenses: null,
        rental: null,
    },
    income: {
        amount: 0,
        extra: '0'
    },
    monthlyIncomeError: false,
    //init
    initialized: false,
    callServicePreApproval: false,
    secondCallInitilized: false,
    preApprovalState: '',
    arrangementFee: 0,
    arrangementPercentage: 0,
    cardDeniedVisible: true,
    subpurposeDrago: null,
    job: PAYROLL_LOAN_JOB_PERMANENT_EMPLOYEE,
    companyMonths: null,
    companyYears: null,
    regime: null,
    recordId: '', //expedient id
    civilStatus: null,
    creditCards: null,
    viewLayoutPreApprovalKOxDTI: false,
    checkboxCirbe: false,
    userType: '',
    validate: false,
    isPrecontractualEmailIsFetiching: false,
    isPrecontractualEmailSent: false,
    isPrecontractualEmailError: false,
    isFetchingPrecontractualDocuments: false,
    isFetchingLoans: false,
    upload: {
        requiredDocs: { IRPF_FILE: false, IRPF130_FILE: false, IRPF100_CLI_FILE: false, EASY_LOAN_CERTIFICATE: false },
        isLoadingFiles: false,
        [IRPF_FILE]: {
            isFetching: false,
            uploaded: false,
            loaded: false,
            error: '',
            notValid: false,
            file: {}
        },
        [IRPF130_FILE]: {
            isFetching: false,
            uploaded: false,
            loaded: false,
            error: '',
            notValid: false,
            file: {}
        },
        [IRPF100_CLI_FILE]: {
            isFetching: false,
            uploaded: false,
            loaded: false,
            error: '',
            notValid: false,
            file: {}
        },
        [EASY_LOAN_CERTIFICATE]: {
            isFetching: false,
            uploaded: false,
            loaded: false,
            error: '',
            notValid: false,
            file: {}
        },
        easyLoanDocumentsState: {},
        isFetching: false,
        isFetchingDocumentsConfirm: false,
        error: ''
    },
    fetchingProposition: false,
    selectedAccount: '',
    errorSelectedAccount: false,
    fechaFinCarencia: '',
    fechaAmortiz: '',
    propositionNumber: '',
    propositionYear: '',
    contractNumber: '',
    paymentDaySelected: PAYMENT_DAY_OTHER,
    vencDate: '',
    agreeCheckbox: false,
    agreeTypeCINECheckbox: false,
    agreeCheckboxStep1: false,
    showErrorMessage: false,
    hasSignaturePattern: true,
    downloadDocumentsError: false,
    documents: null,
    errorDocuments: false,
    isFetchingPrintDocuments: false,
    timestampCheckbox: null,
    hasEasyLoanSuccess: null,
    totalSenorityYears: null,
    totalSenorityMonths: null,
    isFetchingNewPurposes: false,
    monthsWorkingTime: null,
    yearsWorkingTime: null,
    newPurposesList: [],
    isFetchingPersonalData: false,
    maritalStatusList: [],
    maritalStatusDrago: null,
    housingRegimeList: [],
    housingTypeDrago: null,
    subpurposeList: [],
    contractTypeList: [],
    contractType: null,
    cirbeResponse: null,
    employmentLevelList: [],
    employmentLevel: null,
    isFetchingNewJobTypes: false,
    newJobTypesList: [],
    newJobType: null,
    selectedJobType: null,
    enableDocumentsFlow: false,
    isCallingSaveInProgress: false,
    productoActivoSegmentado: null,
    isFetchingINEDocument: false,
    errorEasyLoanTypecIneDocument: false,
    fileEasyLoanTypecIneDocumentId: null,
    fileEasyLoanTypecIneDocument: null,
    totalMonthlyFee: 0,
    initAPIFlag: false,
    isEasyLoanEmailSent: false,
    isEasyLoanEmailError: false,
    officePrintStepTwo: false,
    initializeInitialData: false,
    scrollDown: false,
    cirbeValidate: false,
    submitSuccessfulCC: false,
    stepThree: false,
    scrollDownPolicy: false,
    initialValue: true
});

const processOpeningCommission = (openingCommissionPercentage, openingCommissionMin, loanAmount) => {
    let openingCommissionAmount = loanAmount * openingCommissionPercentage / 100;

    if (openingCommissionMin > openingCommissionAmount) {
        openingCommissionAmount = openingCommissionMin;
    }

    return {
        minimum: openingCommissionMin,
        percentage: openingCommissionPercentage,
        amount: openingCommissionAmount,
        showPercentajeCommission: !(openingCommissionMin !== 0 && openingCommissionPercentage === 0),
        showMinCommission: openingCommissionMin !== 0
    };
};

const processMinInstallmentQuantity = (minInstallmentQuantity) => {
    const roundedValue = ceil(minInstallmentQuantity);
    if (roundedValue > 60) {
        return 60;
    } else if (roundedValue < 12) {
        return 12;
    } else {
        return roundedValue;
    }
}

const validateJobInformationDrago = (state) => {
    let jobError;

    const jobTypeDrago = state.get('newJobType');
    const jobLevelDrago = state.get('employmentLevel');
    const contractTypeDrago = state.get('contractType');

    if (jobTypeDrago) {
        const newJobTypesList = state.get('newJobTypesList');
        const newJobType = newJobTypesList.find(newJobType => jobTypeDrago === newJobType.get('value'));
        const thereAreJobLevel = newJobType.get('jobLevel').find(jobLevel => jobLevel.get('visible'));
        if (thereAreJobLevel) {
            if (jobLevelDrago) {
                const employmentLevelList = typeof state.get('employmentLevelList').toJS !== 'undefined' ?
                    state.get('employmentLevelList').toJS() : state.get('employmentLevelList');
                const employmentLevel = employmentLevelList.find(employmentLevel => jobLevelDrago === employmentLevel.value);
                const contractTypeList = employmentLevel.contractType && typeof employmentLevel.contractType.toJS !== 'undefined' ? employmentLevel.contractType.toJS() : employmentLevel.contractType
                const thereAreContractType = contractTypeList.some(contractType => contractType.visible);
                if (thereAreContractType) {
                    jobError = !contractTypeDrago;
                } else {
                    jobError = false;
                }
            } else {
                jobError = true;
            }
        } else {
            jobError = false;
        }
    } else {
        jobError = true;
    }

    return jobError;
}

const processInstallmentResponse = (state, response) => {
    return state.mergeDeep({
        isFetchingInstallment: false,
        tae: response.tae,
        indCapson: get(response, 'indCapson') || '',
        installment: {
            amount: get(response, 'importePriCuota.importe'),
            currency: get(response, 'importePriCuota.divisa'),
            decimalsLength: decimalsLength(get(response, 'importePriCuota.importe'))
        }
    });
};

const getNewPurposes = (state, action) => {
    const newPurposesList = get(action, 'payload.response.data.categories', []).map(newPurpose => {
        return {
            label: formatText(newPurpose.keyPoeditor),
            value: newPurpose.key,
        }
    });

    return state.merge({
        isFetchingNewPurposes: false,
        newPurposesList,
    });
}

const getNewJobTypesInformation = (state, action) => {
    const newJobTypesList = get(action, 'payload.response.data.jobType', []).map(newJobType => {
        return {
            value: newJobType.key,
            label: formatText(newJobType.keyPoeditor),
            jobLevel: newJobType.jobLevel,
        }
    });

    let employmentLevelList = [];
    if (!!state.get('newJobType')) {
        const employmentLevelElement = newJobTypesList.find(jobType => jobType.value === state.get('newJobType'));
        if (!!employmentLevelElement && employmentLevelElement.jobLevel) {
            employmentLevelList = employmentLevelElement.jobLevel.map(jobLevel => {
                if (jobLevel.visible) {
                    return {
                        value: jobLevel.key,
                        label: formatText(jobLevel.keyPoeditor),
                        contractType: jobLevel.contractType,
                    }
                }
            }).filter(Boolean)
        }
    }

    let contractTypeList = [];
    if (!!state.get('employmentLevel')) {
        const employmentLevel = employmentLevelList.find(employmentLevel => employmentLevel.value === state.get('employmentLevel'));
        employmentLevel.contractType = employmentLevel.contractType.filter(contractType => contractType.visible)
        if (!!employmentLevel && employmentLevel.contractType) {
            contractTypeList = employmentLevel.contractType
                .map(contractType => {
                    return {
                        value: contractType.key,
                        label: formatText(contractType.keyPoeditor),
                    }
                });
        }
    }

    return state.merge({
        isFetchingNewJobTypes: false,
        newJobTypesList,
        employmentLevelList,
        contractTypeList,
    });
}


const mapEmploymentLevelList = (state, action) => {
    const newJobTypesList = state.get('newJobTypesList');
    const newJobTypeValue = action.payload.jobType.value;
    const newJobType = newJobTypesList.find(newJobType => newJobTypeValue === newJobType.get('value'));
    let employmentLevelList = [];
    const thereIsValueVisible = newJobType.get('jobLevel').find(jobLevel => jobLevel.get('visible'));
    if (newJobType.get('jobLevel') && thereIsValueVisible) {
        employmentLevelList = newJobType.get('jobLevel').map(jobLevel => {
            if (jobLevel.get('visible')) {
                return {
                    value: jobLevel.get('key'),
                    label: formatText(jobLevel.get('keyPoeditor')),
                    contractType: jobLevel.get('contractType'),
                }
            }
        });
    }

    const showWorkingTime = showWorkingTimeSection(newJobTypeValue);
    const showTotalWorkingTime = state.get('newJobType') !== OWN_ACCOUNT_DRAGO_OPTION_KEY;

    const totalSenorityYears = showWorkingTime && showTotalWorkingTime ? state.get('totalSenorityYears') : null;
    const totalSenorityMonths = showWorkingTime && showTotalWorkingTime ? state.get('totalSenorityMonths') : null;
    const companyYears = showWorkingTime ? state.get('companyYears') : null;
    const companyMonths = showWorkingTime ? state.get('companyMonths') : null;

    return state.merge({
        newJobType: newJobTypeValue,
        selectedJobType: newJobTypeValue,
        employmentLevel: null,
        employmentLevelList,
        contractType: null,
        contractTypeList: [],
        totalSenorityYears,
        totalSenorityMonths,
        companyYears,
        companyMonths,
    });
}

const mapContractTypeList = (state, action) => {
    const employmentLevelList = state.get('employmentLevelList').toJS();
    const employmentLevelValue = action.payload.employmentLevel;
    const employmentLevel = employmentLevelList.find(employmentLevel => employmentLevelValue === employmentLevel.value);
    employmentLevel.contractType = Immutable.fromJS(employmentLevel.contractType)
    let contractTypeList = [];
    const thereIsValueVisible = employmentLevel.contractType.find(contractType => contractType.get('visible'));
    if (employmentLevel.contractType && thereIsValueVisible) {
        contractTypeList = employmentLevel.contractType.map(contractType => {
            if (contractType.get('visible')) {
                return {
                    value: contractType.get('key'),
                    label: formatText(contractType.get('keyPoeditor')),
                }
            }
        });
    }
    return state.merge({
        employmentLevel: employmentLevelValue,
        contractType: null,
        contractTypeList,
    });
}

const initialize = (state, segmentedLoan) => {
    const rawAmountMax = get(segmentedLoan, 'importeMaximo') || 0;
    const rawAmountMin = get(segmentedLoan, 'importeMinimo') || 0;
    const rawQuotaLimit = get(segmentedLoan, 'limiteCuota') || 0;
    const rawOpeningCommission = get(segmentedLoan, 'comisionApertura') || 0;
    const rawOpeningCommissionMin = get(segmentedLoan, 'comisionAperturaMin') || 0;
    const maxTerm = parseInt(get(segmentedLoan, 'plazoMaximo')) || 0;
    const defaultTermMin = parseInt(get(segmentedLoan, 'plazoMinimo')) || 0;

    const openingCommissionData = parseSpanishNumberToFloat(rawOpeningCommission);
    const openingCommissionMin = parseSpanishNumberToFloat(rawOpeningCommissionMin);
    const maxAmount = parseSpanishNumberToFloat(rawAmountMax);
    const minAmount = parseSpanishNumberToFloat(rawAmountMin);
    const maxAmountError = minAmount > maxAmount;
    const selectedAmount = state.get('selectedAmount') !== 0 ? state.get('selectedAmount'): maxAmount;
    const selectedTerm = state.get('selectedTerm') !== 0 ? state.get('selectedTerm') : maxTerm;

    return state.merge({
        currency: get(segmentedLoan, 'divisa', EURO_TEXT),
        maxAmount,
        minAmount,
        maxAmountError,
        maxTerm,
        minTerm: defaultTermMin,
        minTae: get(segmentedLoan, 'minTae', 0),
        maxTae: get(segmentedLoan, 'maxTae', 0),
        defaultTermMin,
        quotaLimit: parseSpanishNumberToFloat(rawQuotaLimit),
        selectedAmount,
        selectedTerm,
        tin: parseSpanishNumberToFloat(get(segmentedLoan, 'tipoNominal')) || 0,
        type: get(segmentedLoan, 'tipo') || '',
        subtype: get(segmentedLoan, 'subtipo') || '',
        standard: get(segmentedLoan, 'standard') || '',
        aniversaryType: get(segmentedLoan, 'tipoPagoAniversario') || '',
        aniversarySubtype: get(segmentedLoan, 'subtipoPagoAniversario') || '',
        aniversaryStandard: get(segmentedLoan, 'erPagoAniversario') || '',
        openingCommission: processOpeningCommission(openingCommissionData, openingCommissionMin, maxAmount),
        stepReady: true,
        isFetching: false,
        hasEasyLoanSuccess: true,
    });
};
const processOpeningCommissionInitialData = (openingCommissionPercentage, openingCommissionMin, loanAmount) => {
    let openingCommissionAmount = loanAmount * openingCommissionPercentage / 100;

    if (openingCommissionMin > openingCommissionAmount) {
        openingCommissionAmount = openingCommissionMin;
    }

    return {
        minimum: openingCommissionMin,
        percentage: openingCommissionPercentage,
        amount: openingCommissionAmount,
        showPercentajeCommission: !(openingCommissionMin !== 0 && openingCommissionPercentage === 0),
        showMinCommission: openingCommissionMin !== 0
    };
};
const initializeInitialData = (state, { response }) => {
    const currency = get(response, 'loanProductInformation.currencyCode', '')
    const selectedTerm = get(response, 'loanRecordInformation.term', '')
    const totalAmount = get(response, 'totalAmount', '')
    const rawAmountMax = get(response, 'loanProductInformation.maxAmount', '') || 0;
    const rawAmount = get(response, 'loanRecordInformation.amount', '');
    const rawAmountMin = get(response, 'loanProductInformation.minAmount', '') || 0;
    const maxAmount = parseSpanishNumberToFloat(rawAmountMax);
    const minAmount = parseSpanishNumberToFloat(rawAmountMin);
    const maxAmountError = minAmount > maxAmount;
    const maxTerm = parseInt(get(response, 'loanProductInformation.maxTerm', '')) || 0;
    const defaultTermMin = parseInt(get(response, 'loanProductInformation.minTerm', '')) || 0;
    const tin = get(response, 'loanRecordInformation.tin');
    const type = get(response, 'loanRecordInformation.productType', '');
    const subtype = get(response, 'loanRecordInformation.productSubType', '');
    const recordId = get(response, 'loanRecordInformation.recordId', '');
    const standard = get(response, 'loanRecordInformation.endOfMonthReferenceStandard', '') || '';
    const aniversaryStandard = get(response, 'loanRecordInformation.currentDateReferenceStandard', '') || '';
    const rawOpeningCommission = get(response, 'loanRecordInformation.commission') || 0;
    const openingCommissionData = parseSpanishNumberToFloat(rawOpeningCommission);
    const rawOpeningCommissionMin = get(response, 'loanRecordInformation.minimumOpeningCommission') || 0;
    const openingCommissionMin = parseSpanishNumberToFloat(rawOpeningCommissionMin);
    const openingCommission = processOpeningCommissionInitialData(openingCommissionData, openingCommissionMin, maxAmount)
    const selectedPurpose = get(response, 'loanRecordInformation.purposeDrago', '')
    const income = get(response, 'financialInformation.netIncome', '')
    const expenses = get(response, 'financialInformation.otherLoanInstallments', '')
    const rental = get(response, 'financialInformation.rent', '')
    const selectedJobType = get(response, 'financialInformation.jobTypeDrago', '')
    const employmentLevel = get(response, 'financialInformation.jobLevelDrago', '')
    let contractType = get(response, 'financialInformation.contractTypeDrago', '')
    let employmentLevelList = [];
    let contractTypeList = [];
    const newJobTypesList = state.get('newJobTypesList');
    const newJobType = newJobTypesList.find(newJobType => selectedJobType === newJobType.get('value'));
    if (newJobType) {


        const thereIsValueVisible = newJobType.get('jobLevel').find(jobLevel => jobLevel.get('visible'));
        if (newJobType.get('jobLevel') && thereIsValueVisible) {
            employmentLevelList = newJobType.get('jobLevel').map(jobLevel => {
                if (jobLevel.get('visible')) {
                    return {
                        value: jobLevel.get('key'),
                        label: formatText(jobLevel.get('keyPoeditor')),
                        contractType: jobLevel.get('contractType'),
                    }
                }
            });
        }
        if (employmentLevel) {
            contractTypeList = employmentLevelList.toJS().find(
                jobLevel => jobLevel.value === employmentLevel)?.contractType.toJS().map(contract => ({
                    value: contract.key,
                    label: formatText(contract.keyPoeditor),
                }));
        }
    }
    return state.merge({
        amount: rawAmount,
        initialized: true,
        selectedTerm,
        isFetching: false,
        secondCallInitilized: false,
        error: false,
        recordId,
        currency,
        outcome: {
            income,
            expenses,
            rental,
        },
        initializeInitialData: true,
        selectedJobType,
        employmentLevel,
        contractTypeList,
        employmentLevelList,
        newJobType: selectedJobType ? true : null,
        contractType,
        totalAmount,
        selectedPurpose,
        maxAmount,
        minAmount,
        maxAmountError,
        maxTerm,
        minTerm: defaultTermMin,
        minTae: 0,
        maxTae: 0,
        defaultTermMin,
        quotaLimit: minAmount,
        selectedAmount: rawAmount,
        tin,
        type,
        subtype,
        standard,
        aniversaryType: type,
        aniversarySubtype: subtype,
        aniversaryStandard,
        openingCommission,
        stepReady: true,
        isFetching: false,
        hasEasyLoanSuccess: true,

    });
};

const validateStepApproved = (state, action) => {
    switch (action.payload.step.step) {
        case WIZARD_FIRST_STEP:
            const valid = state.get('agreeTypeCINECheckbox') || state.get('officePrintStepTwo') || state.get('isEasyLoanEmailSent');
            return state.setIn(['steps', FIRST_STEP, 'valid'], valid)
                .merge({
                    visibleStep: valid ? WIZARD_THIRD_STEP : WIZARD_SECOND_STEP,
                    beforeStep: valid ? state.get('visibleStep') : state.get('beforeStep'),
                    errorAsnef: undefined,
                    agreeCheckbox: false,
                    showErrorMessage: false,
                });

        case WIZARD_SECOND_STEP:
            return state;

        default:
            return state;
    }


}
const validateStep = (state, action) => {
    switch (action.payload.step) {
        case WIZARD_FIRST_STEP:
            const emptyPurposeMessage = !!state.get('selectedPurpose');
            const emptyIncome = state.getIn(['outcome', 'income']);
            const jobError = validateJobInformationDrago(state, true);
            const isValid = !state.get('isFetchingInstallment') &&
                !state.get('isFetchingMinInstallmentQuantity') && emptyPurposeMessage && !!emptyIncome && !jobError;

            return state.setIn(['steps', FIRST_STEP, 'valid'], isValid)
                .merge({
                    showPurposeError: !emptyPurposeMessage,
                    monthlyIncomeError: !emptyIncome,
                    visibleStep: isValid ? WIZARD_SECOND_STEP : WIZARD_FIRST_STEP,
                    beforeStep: isValid ? state.get('visibleStep') : state.get('beforeStep'),
                    validate: true,
                });

        case WIZARD_SECOND_STEP:
            const valid = state.get('agreeTypeCINECheckbox') || state.get('officePrintStepTwo') || state.get('isEasyLoanEmailSent');
            return state.setIn(['steps', SECOND_STEP, 'valid'], valid)
                .merge({
                    visibleStep: valid ? WIZARD_THIRD_STEP : WIZARD_SECOND_STEP,
                    beforeStep: valid ? state.get('visibleStep') : state.get('beforeStep'),
                    errorAsnef: undefined,
                    agreeCheckbox: false,
                    showErrorMessage: false,
                });
        case WIZARD_THIRD_STEP:
            return state.setIn(['steps', THIRD_STEP, 'valid'], true)
        default:
            return state;
    }
}

const convertTypeFile = (uploadName) => {
    let documentType;

    if (uploadName === EASY_LOAN_CERTIFICATE) {
        documentType = NOM_VL;
    }
    else if (uploadName === IRPF_FILE) {
        documentType = IRPF100;
    }
    else if (uploadName === IRPF130_FILE) {
        documentType = IRPF130;
    }
    else if (uploadName === IRPF100_CLI_FILE) {
        documentType = IRPF100_CLI;
    }
    return documentType;
}

const clearFileStatus = (state, uploadName) => {
    let associatedDocuments = state.getIn(['upload', 'easyLoanDocumentsState', 'associatedDocuments']);
    if (associatedDocuments) {
        associatedDocuments = associatedDocuments.map(item => {
            if (item.get('documentType') === convertTypeFile(uploadName)) {
                item = item.set('documentState', '');
            }
            return item;
        });
    }
    return state.setIn(['upload', 'easyLoanDocumentsState', 'associatedDocuments'], associatedDocuments);
}

const removeFile = (state, config, uploadName) => {
    state = clearFileStatus(state, uploadName);

    return state.mergeDeep({
        upload: {
            isLoadingFiles: false,
            [uploadName]: config
        }
    })
}


const loadingFile = (state, uploadName) => {

    return state.mergeDeep({
        upload: {
            isLoadingFiles: true,
            [uploadName]: {
                isFetching: true,
                error: ''
            }
        }
    });
}

const createFileObject = (documentType, valid) => (valid ? { name: getTranslatedDocumentName(documentType) } : {});

const loadFilesFromServer = (state, response) => {

    const { associatedDocuments, associatedReceipts } = response;
    let documentIrpf130 = find(associatedDocuments, document => document.documentType === IRPF130);
    let documentIrpf100CLI = find(associatedDocuments, document => document.documentType === IRPF100_CLI);
    let documentIrpf100CLI2 = find(associatedDocuments, document => document.documentType === IRPF100_CLI_2);
    let documentIrpf100 = find(associatedDocuments, document => document.documentType === NEW_IRPF100_FILE);
    let documentIrpf100CLI3 = find(associatedDocuments, document => document.documentType === IRPF100_CLI_3);
    let documentIrpf100CLI4 = find(associatedDocuments, document => document.documentType === IRPF100_CLI_4);
    const documentIrpf = find(associatedDocuments, document => document.documentType === IRPF100);
    const documentNominaCertificate = find(associatedDocuments, document => document.documentType === NOM_VL);

    const irpfIsPendingValidation = !!documentIrpf && documentIrpf.documentState === PEND_VAL;
    const irpf130IsPendingValidation = !!documentIrpf130 && documentIrpf130.documentState === PEND_VAL;
    const irpf100CLIIsPendingValidation = !!documentIrpf100CLI && documentIrpf100CLI.documentState === PEND_VAL;
    const irpf100IsPendingValidation = !!documentIrpf100 && documentIrpf100.documentState === PEND_VAL;
    const irpf100CLIIsPendingValidation2 = !!documentIrpf100CLI2 && documentIrpf100CLI2.documentState === PEND_VAL;
    const irpf100CLIIsPendingValidation3 = !!documentIrpf100CLI3 && documentIrpf100CLI3.documentState === PEND_VAL;
    const irpf100CLIIsPendingValidation4 = !!documentIrpf100CLI4 && documentIrpf100CLI4.documentState === PEND_VAL;
    const certificateIsPendingValidation = !!documentNominaCertificate && documentNominaCertificate.documentState === PEND_VAL;

    const irpfIsNotValid = !!documentIrpf && documentIrpf.documentState === NO_VALIDO;
    const irpf130IsNotValid = !!documentIrpf130 && documentIrpf130.documentState === NO_VALIDO;
    const irpf100CLIIsNotValid = !!documentIrpf100CLI && documentIrpf100CLI.documentState === NO_VALIDO;
    const irpf100IsNotValid = !!irpf100IsPendingValidation && irpf100IsPendingValidation.documentState === NO_VALIDO;
    const irpf100CLIIsNotValid2 = !!documentIrpf100CLI2 && documentIrpf100CLI2.documentState === NO_VALIDO;
    const irpf100CLIIsNotValid3 = !!documentIrpf100CLI3 && documentIrpf100CLI3.documentState === NO_VALIDO;
    const irpf100CLIIsNotValid4 = !!documentIrpf100CLI4 && documentIrpf100CLI4.documentState === NO_VALIDO;
    const certificateIsNotValid = !!documentNominaCertificate && (documentNominaCertificate.documentState === NO_VALIDO);

    let irpfLoaded;
    let irpf130Loaded;
    let irpf100CLILoaded;
    let irpf100Loaded;
    let irpf100CLILoaded2;
    let irpf100CLILoaded3;
    let irpf100CLILoaded4;
    let nominaCertificateLoaded;
    let fileInfoIrpf;
    let fileInfoIrpf130;
    let fileInfoIrpf100CLI;
    let fileInfoIrpf100;
    let fileInfoIrpf100CLI2;
    let fileInfoIrpf100CLI3;
    let fileInfoIrpf100CLI4;
    let fileInfoNominaCertificate;

    const documents = {
        IRPF_FILE: documentIrpf,
        IRPF130_FILE: documentIrpf130,
        IRPF100_FILE: documentIrpf100,
        IRPF100_CLI_FILE: documentIrpf100CLI,
        IRPF100_CLI_FILE_2: documentIrpf100CLI2,
        IRPF100_CLI_FILE_3: documentIrpf100CLI3,
        IRPF100_CLI_FILE_4: documentIrpf100CLI4,
        EASY_LOAN_CERTIFICATE: documentNominaCertificate
    };

    const requiredDocs = Object.fromEntries(
        Object.entries(documents).filter(([key, value]) => value !== undefined)
    );
    if (!irpfIsNotValid) {
        irpfLoaded = irpfIsPendingValidation;
        fileInfoIrpf = createFileObject(IRPF100, irpfIsPendingValidation);
    } else {
        irpfLoaded = !irpfIsNotValid;
        fileInfoIrpf = createFileObject(IRPF100, true);
    }

    if (!irpf130IsNotValid) {
        irpf130Loaded = irpf130IsPendingValidation;
        fileInfoIrpf130 = createFileObject(IRPF130, irpf130IsPendingValidation);
    } else {
        irpf130Loaded = !irpf130IsNotValid;
        fileInfoIrpf130 = createFileObject(IRPF130, true);
    }

    if (!irpf100CLIIsNotValid) {
        irpf100CLILoaded = irpf100CLIIsPendingValidation;
        fileInfoIrpf100CLI = createFileObject(IRPF100_CLI, irpf100CLIIsPendingValidation);
    } else {
        irpf100CLILoaded = !irpf100CLIIsNotValid;
        fileInfoIrpf100CLI = createFileObject(IRPF100_CLI, true);
    }
    if (!irpf100IsNotValid) {
        irpf100Loaded = irpf100IsPendingValidation;
        fileInfoIrpf100 = createFileObject(NEW_IRPF100_FILE, irpf100IsPendingValidation);
    } else {
        irpf100Loaded = !irpf100IsNotValid;
        fileInfoIrpf100 = createFileObject(NEW_IRPF100_FILE, true);
    }
    if (!irpf100CLIIsNotValid2) {
        irpf100CLILoaded2 = irpf100CLIIsPendingValidation2;
        fileInfoIrpf100CLI2 = createFileObject(IRPF100_CLI_2, irpf100CLIIsPendingValidation2);
    } else {
        irpf100CLILoaded2 = !irpf100CLIIsNotValid2;
        fileInfoIrpf100CLI2 = createFileObject(IRPF100_CLI_2, true);
    }
    if (!irpf100CLIIsNotValid3) {
        irpf100CLILoaded3 = irpf100CLIIsPendingValidation3;
        fileInfoIrpf100CLI3 = createFileObject(IRPF100_CLI_3, irpf100CLIIsPendingValidation3);
    } else {
        irpf100CLILoaded3 = !irpf100CLIIsNotValid3;
        fileInfoIrpf100CLI3 = createFileObject(IRPF100_CLI_3, true);
    }
    if (!irpf100CLIIsNotValid4) {
        irpf100CLILoaded4 = irpf100CLIIsPendingValidation4;
        fileInfoIrpf100CLI4 = createFileObject(IRPF100_CLI_4, irpf100CLIIsPendingValidation4);
    } else {
        irpf100CLILoaded4 = !irpf100CLIIsNotValid4;
        fileInfoIrpf100CLI4 = createFileObject(IRPF100_CLI_4, true);
    }
    if (!certificateIsNotValid) {
        nominaCertificateLoaded = certificateIsPendingValidation;
        fileInfoNominaCertificate = createFileObject(NOM_VL, certificateIsPendingValidation);
    } else {
        nominaCertificateLoaded = !certificateIsNotValid;
        fileInfoNominaCertificate = createFileObject(NOM_VL, true);
    }

    let files = [];

    if (associatedReceipts) {
        files = associatedReceipts.map((file, idx) => {
            const fileIsNotValid = file.documentState === NO_VALIDO || ERROR_DOCUMENTACION;

            return Immutable.fromJS({
                isFetching: false,
                uploaded: true,
                loaded: true,
                error: '',
                notValid: fileIsNotValid,
                idx,
                documentId: file.documentReceiptId,
                newName: file.documentName,
                file: {
                    name: file.documentName
                }
            });
        });
    }

    const emptyConfig = {
        documentId: null,
        isFetching: false,
        loaded: false,
        error: '',
        uploaded: false,
        idx: files.length,
        newName: ''
    };

    if (files.length < MAX_UPLOAD_EXPENSES_COMPONENTS) {
        files = files.concat([Immutable.fromJS(emptyConfig)]);
    }

    return state.merge({
        upload: {
            requiredDocs,
            isLoadingFiles: false,
            easyLoanDocumentsState: response,
            [IRPF_FILE]: {
                isFetching: false,
                uploaded: irpfLoaded,
                loaded: irpfLoaded,
                error: '',
                notValid: irpfIsNotValid,
                file: fileInfoIrpf
            },
            [IRPF130_FILE]: {
                isFetching: false,
                uploaded: irpf100Loaded,
                loaded: irpf100Loaded,
                error: '',
                notValid: irpf100IsNotValid,
                file: fileInfoIrpf100
            },
            [IRPF100_FILE]: {
                isFetching: false,
                uploaded: irpf100CLILoaded2,
                loaded: irpf100CLILoaded2,
                error: '',
                notValid: irpf100CLIIsNotValid2,
                file: fileInfoIrpf100CLI2
            },
            [IRPF100_CLI_FILE]: {
                isFetching: false,
                uploaded: irpf100CLILoaded,
                loaded: irpf100CLILoaded,
                error: '',
                notValid: irpf100CLIIsNotValid,
                file: fileInfoIrpf100CLI
            },
            [IRPF100_CLI_FILE_2]: {
                isFetching: false,
                uploaded: irpf100CLILoaded2,
                loaded: irpf100CLILoaded2,
                error: '',
                notValid: irpf100CLIIsNotValid2,
                file: fileInfoIrpf100CLI2
            },
            [IRPF100_CLI_FILE_3]: {
                isFetching: false,
                uploaded: irpf100CLILoaded3,
                loaded: irpf100CLILoaded3,
                error: '',
                notValid: irpf100CLIIsNotValid3,
                file: fileInfoIrpf100CLI3
            },
            [IRPF100_CLI_FILE_4]: {
                isFetching: false,
                uploaded: irpf100CLILoaded4,
                loaded: irpf100CLILoaded4,
                error: '',
                notValid: irpf100CLIIsNotValid4,
                file: fileInfoIrpf100CLI4
            },
            [EASY_LOAN_CERTIFICATE]: {
                isFetching: false,
                uploaded: nominaCertificateLoaded,
                loaded: nominaCertificateLoaded,
                error: '',
                notValid: certificateIsNotValid,
                file: fileInfoNominaCertificate
            },
        },
        isFetching: false
    });
}

const changeUploadConfig = (state, config, uploadName, idx, error = false, isLoadingFiles = false) => {

    state = state.mergeDeep({
        upload: {
            isLoadingFiles,
            [uploadName]: {
                ...config,
                idx,
                error
            }
        }
    });
    return state;

}

const setFileInvalidError = () => {
}

const setErrorState = (state, action) => {
    const uploadName = get(action, 'payload.uploadName', '');
    const idx = get(action, 'payload.idx', FILE_FIRST_INDEX);
    const config = {
        isFetching: false,
        loaded: false,
        uploaded: false,
        error: get(action, 'payload.message', ''),
        idx
    };
    const error = true;

    return changeUploadConfig(
        state,
        config,
        uploadName,
        idx,
        error
    );
}


const contractEasyLoanTypeCReducer = handleActions(
    {
        [simpleActions.contractEasyLoanDownloadDocument]: state =>
            state.set('isFetchingZip', true),
        [simpleActions.contractEasyLoanDownloadDocumentError]: state =>
            state.merge({
                isFetchingZip: false,
                downloadDocumentsError: true
            }),
        [simpleActions.contractEasyLoanDownloadDocumentSuccess]: state =>
            state.merge({
                isFetchingZip: false,
                downloadDocumentsError: false
            }),
        [simpleActions.contractEasyLoanFormalize]: state =>
            state.merge({
                isFetching: true,
                error: false,
                submitSuccessful: false
            }),
        [simpleActions.contractEasyLoanFormalizeError]: state =>
            state.merge({
                isFetching: false,
                submitSuccessful: false,
                error: true
            }),
        [simpleActions.contractEasyLoanFormalizeSuccess]: state =>
            state.set('submitSuccessful', true),
        [simpleActions.contractEasyLoanTypecGetProposition]: state =>
            state.set('fetchingProposition', true),
        [simpleActions.contractEasyLoanTypecGetPropositionError]: state =>
            state.merge({
                fetchingProposition: false,
                error: true
            }),
        [simpleActions.contractEasyLoanTypecGetPropositionSuccess]: (state, action) =>
            state.merge({
                propositionNumber: get(action.payload, 'propuesta.numerodepropuesta'),
                propositionYear: get(action.payload, 'propuesta.anio'),
                contractNumber: get(action.payload, 'contrato.numerodecontrato'),
                fechaVenci: get(action.payload, 'fechaVenci'),
                fetchingProposition: false
            }),
        [simpleActions.contractEasyLoanTypecGetTotalImport]: state =>
            state.set('fetchingTotalAmount', true),
        [simpleActions.contractEasyLoanTypecGetTotalImportError]: state =>
            state.merge({
                isFetching: false,
                submitSuccessful: false,
                error: true
            }),
        [simpleActions.contractEasyLoanTypecGetTotalImportSuccess]: (state, action) =>
            state.merge({
                fetchingTotalAmount: false,
                totalAmount: action.payload.totalAmount
            }),
        [simpleActions.contractEasyLoanHiringDocuments]: state =>
            state.merge({
                isFetchingDocuments: true,
                errorDocuments: false
            }),
        [simpleActions.contractEasyLoanHiringDocumentsError]: state =>
            state.merge({
                isFetchingDocuments: false,
                errorDocuments: true
            }),
        [simpleActions.contractEasyLoanHiringDocumentsSuccess]: (state, action) =>
            state.merge({
                isFetchingDocuments: false,
                documents: action.payload.response,
                errorDocuments: false
            }),
        [simpleActions.contractEasyLoanTypecInstallment]: state =>
            state.merge({
                isFetchingInstallment: true,
                initialValue: false
            }),
        [simpleActions.contractEasyLoanTypecInstallmentError]: state =>
            state.merge({
                isFetching: false,
                submitSuccessful: false,
                error: true
            }),
        [simpleActions.contractEasyLoanTypecInstallmentSuccess]: (state, action) =>
            processInstallmentResponse(state, action.payload.response),
        [simpleActions.contractEasyLoanTypecMinInstallment]: state =>
            state.set('isFetchingMinInstallmentQuantity', true),
        [simpleActions.contractEasyLoanTypecMinInstallmentError]: state =>
            state.merge({
                minTerm: state.get('defaultTermMin'),
                maxTerm: state.get('maxTerm'),
                isFetchingMinInstallmentQuantity: false
            }),
        [simpleActions.contractEasyLoanTypecMinInstallmentSuccess]: (state, action) =>
            state.merge({
                minTerm: processMinInstallmentQuantity(action.payload.minimumInstallmentQuantity),
                maxTerm: state.get('maxTerm'),
                isFetchingMinInstallmentQuantity: false
            }),
        [simpleActions.contractEasyLoanNotAvailable]: state =>
            state.merge({
                notAvailable: true,
                stepReady: false,
                hasEasyLoanSuccess: false,
            }),
        [simpleActions.contractEasyLoanPreFill]: state =>
            state.set('isFetching', true),
        [simpleActions.easyLoanTypecRequestSaveInProgress]: (state) =>
            state.merge({
                callServicePreApproval: true,
                isCallingSaveInProgress: true
            }),
        [simpleActions.easyLoanTypecRequestSaveInProgressSuccess]: (state) =>
            state.merge({ isCallingSaveInProgress: false }),
        [simpleActions.contractEasyLoanTypecSetNewJobType]: (state, action) =>
            mapEmploymentLevelList(state, action),
        [simpleActions.contractEasyLoanTypecSetEmploymentLevel]: (state, action) =>
            mapContractTypeList(state, action),
        [simpleActions.contractEasyLoanTypecSetContractType]: (state, action) =>
            state.merge({
                contractType: action.payload.contractType,
            }),
        [simpleActions.contractEasyLoanTypecSetOutcome]: (state, action) =>
            state.mergeDeep({ outcome: action.payload.outcome }),
        [simpleActions.contractEasyLoanTypecSetError]: (state, action) =>
            state.set('monthlyIncomeError', action.payload.incomeError),
        [simpleActions.contractEasyLoanTypecInitialize]: (state) =>
            state.merge({
                error: false,
                isFetching: true,
                callServicePreApproval: true,
                monthlyIncomeError: false,
                agreeCheckboxStep1: false,
            }),
        [simpleActions.contractEasyLoanTypecInitializeSuccess]: (state, action) =>
            initializeInitialData(state, action.payload),
        [combineActions(
            simpleActions.contractEasyLoanTypecInitializeError,
            simpleActions.easyLoanTypecRequestSaveInProgressError,
            simpleActions.contractEasyLoanTypecRequestApprovalError
        )]: (state) =>
                state.merge({
                    isFetchingInstallment: false,
                    isFetching: false,
                    error: true,
                    isCallingSaveInProgress: false,
                    validate: true,
                }),
        [simpleActions.contractEasyLoanTypecAsnefFailure]: (state) =>
            state.merge({
                isFetchingInstallment: false,
                isFetching: false,
                errorAsnef: true,
                isCallingSaveInProgress: false,
                validate: false,
                }),
        [simpleActions.contractEasyLoanTypecAsnefFailureReset]: (state) =>
            state.merge({
                errorAsnef: false,
            }),
        [simpleActions.getEasyLoanTypecIneDocument]: (state) =>
            state.merge({
                isFetchingINEDocument: true,
                errorEasyLoanTypecIneDocument: false
            }),
        [simpleActions.getEasyLoanTypecIneDocumentSuccess]: (state, action) =>
            state.merge({
                fileEasyLoanTypecIneDocument: `data:application/pdf;base64,${action.payload.base64}`,
                fileEasyLoanTypecIneDocumentId: action.payload.documentId,
                errorEasyLoanTypecIneDocument: false,
                isFetchingINEDocument: false
            }),
        [simpleActions.contractEasyLoanTypecIneToggleAgreeCheckbox]: state =>
            state.merge({
                agreeTypeCINECheckbox: !state.get('agreeTypeCINECheckbox'),
            }),
        [simpleActions.getEasyLoanTypecIneDocumentError]: (state) =>
            state.merge({
                errorEasyLoanTypecIneDocument: true,
                isFetchingINEDocument: false
            }),
        [simpleActions.contractEasyLoanTypecEmailSuccess]: state =>
            state.merge({
                isEasyLoanEmailSent: true,
                isEasyLoanEmailError: false
            }),
        [simpleActions.contractEasyLoanTypecEmailError]: state =>
            state.merge({
                isEasyLoanEmailSent: false,
                isEasyLoanEmailError: true
            }),
        [simpleActions.contractEasyLoanTypecPrintStep2]: state =>
            state.set('officePrintStepTwo', true),
        [simpleActions.contractEasyLoanTypecGetJobs]: (state) =>
            state.set('isFetchingNewJobTypes', true),
        [simpleActions.contractEasyLoanTypecGetJobsError]: (state) =>
            state.set('isFetchingNewJobTypes', false),
        [simpleActions.contractEasyLoanTypecGetJobsSuccess]: (state, action) =>
            getNewJobTypesInformation(state, action),
        [simpleActions.easyLoanTypecRequestGetLoansForExpenses]: state =>
            state.set('isFetchingLoans', true),
        [simpleActions.easyLoanTypecRequestGetLoansForExpensesError]: state =>
            state.merge({
                isFetchingLoans: false,
                error: true
            }),
        [simpleActions.easyLoanTypecRequestGetLoansForExpensesSuccess]: (state, action) =>
            state.merge({
                isFetchingLoans: false,
                loans: get(action, 'payload.response.loans', []),
                totalMonthlyFee: get(action, 'payload.response.totalMonthlyFee', [])
            }),
        [simpleActions.contractEasyLoanPreFillError]: state =>
            state.set('error', true),
        [simpleActions.contractEasyLoanPreFillSuccess]: (state, action) =>
            initialize(state, action.payload),
        [simpleActions.contractEasyLoanTypecResetStep]: state =>
            state.mergeDeep(setInitialState()),
        [simpleActions.contractEasyLoanSetAccount]: (state, action) =>
            state.merge({
                selectedAccount: action.payload.accountId,
                errorSelectedAccount: false
            }),
        [simpleActions.contractEasyLoanSetLoanAmount]: (state, action) => {
            const openingCommissionData = state.get('openingCommission');
            const openingCommission = processOpeningCommission(openingCommissionData.get('percentage'), openingCommissionData.get('minimum'), action.payload.selectedAmount);

            return state.merge({
                selectedAmount: action.payload.selectedAmount,
                selectedTerm: state.get('selectedTerm'), // Bussiness Rule: we always set the terms slider to top when changing the selectedAmount.
                openingCommission
            });
        },
        [simpleActions.contractEasyLoanTypecSetPurpose]: (state, action) =>
            state.merge({
                showPurposeError: false,
                selectedPurpose: action.payload.purpose
            }),
        [simpleActions.contractEasyLoanSetPaymentDay]: (state, action) =>
            state.set('paymentDaySelected', action.payload.paymentDay),
        [simpleActions.contractEasyLoanTypecSetStep]: (state, action) =>
            state.set('visibleStep', action.payload.visibleStep),
        [simpleActions.contractEasyLoanTypecSetTerm]: (state, action) =>
            state.set('selectedTerm', action.payload.term),
        [simpleActions.contractEasyLoanToggleAgreeCheckbox]: state =>
            state.merge({
                agreeCheckbox: !state.get('agreeCheckbox'),
                showErrorMessage: false,
                timestampCheckbox: new Date().getTime(),
            }),
        [simpleActions.contractEasyLoanTypecToggleAgreeCheckbox]: state =>
            state.merge({
                agreeCheckboxStep1: !state.get('agreeCheckboxStep1'),
            }),
        [simpleActions.contractEasyLoanTypecRequestApproval]: state =>
            state.merge({
                error: false,
                isFetching: true,
                callServicePreApproval: false
            }),
        [simpleActions.contractEasyLoanTypecRequestApprovalApproved]: (state, action) => {
            const emptyPurposeMessage = !!state.get('selectedPurpose');
            const emptyIncome = state.getIn(['outcome', 'income']);
            const jobError = validateJobInformationDrago(state, true);
            const isValid = !state.get('isFetchingInstallment') &&
                !state.get('isFetchingMinInstallmentQuantity') && emptyPurposeMessage && !!emptyIncome && !jobError;
            return state.setIn(['steps', FIRST_STEP, 'valid'], isValid)
                .merge({
                    showPurposeError: !emptyPurposeMessage,
                    isFetching: false,
                    errorAsnef: false,
                    visibleStep: isValid ? WIZARD_SECOND_STEP : WIZARD_FIRST_STEP,
                    beforeStep: isValid ? state.get('visibleStep') : state.get('beforeStep'),
                    cirbeResponse: action.payload.response,
                    validate: true,
                });
        },
        [simpleActions.contractEasyLoanTypecRequestApprovalRejected]: (state, action) =>
            state.merge({
                isFetching: false,
                rejected: true,
                error: true,
                cirbeResponse: action.payload.response
            }),
        [simpleActions.contractEasyLoanTypecGetPurposes]: (state) =>
            state.set('isFetchingNewPurposes', true),
        [simpleActions.contractEasyLoanTypecGetPurposesError]: (state) =>
            state.set('isFetchingNewPurposes', false),
        [simpleActions.contractEasyLoanTypecGetPurposesSuccess]: (state, action) =>
            getNewPurposes(state, action),
        [simpleActions.payrollLoanRequestEmailPrecontractual]: state =>
            state.merge({
                isPrecontractualEmailIsFetching: true,
                isPrecontractualEmailSent: false,
                isPrecontractualEmailError: false,
            }),
        [simpleActions.payrollLoanRequestEmailPrecontractualSuccess]: state =>
            state.merge({
                isPrecontractualEmailIsFetching: false,
                isPrecontractualEmailSent: true,
                isPrecontractualEmailError: false,
            }),
        [simpleActions.payrollLoanRequestEmailPrecontractualError]: state =>
            state.merge({
                isPrecontractualEmailIsFetching: false,
                isPrecontractualEmailSent: false,
                isPrecontractualEmailError: true,
            }),
        [simpleActions.contractEasyLoanTypecValidateStep]: (state, action) =>
            validateStep(state, action),
        [simpleActions.contractEasyLoanValidateStepApproved]: (state, action) =>
            validateStepApproved(state, action),
        [simpleActions.contractEasyLoanTypecWillLeave]: (state) =>
            state.mergeDeep(setInitialState(), { showTypeC: state.get('showTypeC') }),
        [simpleActions.contractShowTypeC]: (state, action) =>
            state.merge({
                showTypeC: true,
                productoActivoSegmentado: action.payload,
            }),
        [simpleActions.contractEasyLoanDownloadPrintDocument]: state =>
            state.set('isFetchingPrintDocuments', true),
        [combineActions(
            simpleActions.contractEasyLoanDownloadPrintDocumentError,
            simpleActions.contractEasyLoanDownloadPrintDocumentSuccess
        )]: state =>
                state.set('isFetchingPrintDocuments', false),
        [simpleActions.easyLoanRequestSaveInProgressError]: state =>
            state.merge({
                isFetchingInstallment: false,
                isFetching: false,
                error: true,
                isCallingSaveInProgress: false
            }),
        [simpleActions.easyLoanRequestLoadFiles]: state =>
            state.mergeDeep({
                error: false,
                isFetching: true,
                callServicePreApproval: true,
                upload: {
                    isFetching: true
                }
            }),
        [simpleActions.easyLoanRequestLoadFilesSuccess]: (state, action) =>
            loadFilesFromServer(
                state,
                get(action, 'payload.response') || { associatedDocuments: [], associatedReceipts: [] }
            ),
        [simpleActions.easyLoanRequestLoadFilesError]: state =>
            state.mergeDeep({
                isFetching: false,
            }),
        [combineActions(
            simpleActions.easyLoanRequestUploadFileRemove,
            simpleActions.easyLoanRequestUploadFile
        )]: (state, action) =>
                loadingFile(
                    state,
                    action.payload.uploadName,
                    action.payload.idx
                ),
        [simpleActions.easyLoanRequestUploadFileDisable]: (state) =>
            state.set('enableDocumentsFlow', false),
        [combineActions(
            simpleActions.easyLoanRequestUploadFileError,
            simpleActions.easyLoanRequestUploadFileRemoveError
        )]: (state, action) =>
                setErrorState(
                    state,
                    action
                ),
        [simpleActions.easyLoanRequestUploadFileInvalidError]: (state, action) =>
            setFileInvalidError(
                state,
                get(action, 'payload.idx', FILE_FIRST_INDEX)
            ),
        [simpleActions.easyLoanRequestUploadFileLoad]: (state, action) => changeUploadConfig(
            state,
            {
                isFetching: false,
                error: '',
                loaded: true,
                uploaded: true,
                idx: get(action, 'payload.response.idx', FILE_FIRST_INDEX),
                documentId: get(action, 'payload.documentId', null),
                newName: get(action, 'payload.newName', ''),
                file: get(action, 'payload.response.file', '')
            },
            get(action, 'payload.response.uploadName', ''),
            get(action, 'payload.response.idx', FILE_FIRST_INDEX)
        ),
        [simpleActions.easyLoanRequestUploadFileRemoveSuccess]: (state, action) =>
            removeFile(
                state,
                {
                    file: null,
                    isFetching: false,
                    loaded: false,
                    error: '',
                    uploaded: false,
                    newName: '',
                },
                get(action, 'payload.response.uploadName', ''),
                get(action, 'payload.response.idx', FILE_FIRST_INDEX)
            ),
        [simpleActions.easyLoanRequestUploadStartConfirm]: state =>
            state.setIn(['upload', 'isFetchingDocumentsConfirm'], true),
        [simpleActions.easyLoanRequestUploadFileReset]: (state) =>
            state.merge({ upload: setInitialState().get('upload') }),
        [simpleActions.easyLoanRequestUploadFileSubmit]: (state) =>
            state.set('submitSuccessful', true),
        [simpleActions.easyLoanRequestUploadFileSubmitContactCenter]: (state) =>
            state.set('submitSuccessfulCC', true),
        [simpleActions.easyLoanRequestUploadFileSuccess]: (state, action) =>
            changeUploadConfig(
                state,
                { isFetching: false, uploaded: true },
                action.payload.uploadName
            ),
        [simpleActions.contractEasyLoanTypecReadDocument]: (state) =>
            state.set('scrollDown', true),
        [simpleActions.contractEasyLoanTypecStepThree]: (state) =>
            state.set('stepThree', true),
        [simpleActions.contractEasyLoanTypecReadDocumentPolicy]: (state) =>
            state.set('scrollDownPolicy', true),
        [simpleActions.contractEasyLoanTypecUpdateLoanInfo]: (state, action) =>
            state.merge({
                selectedAmount: action.payload.selectedAmount,
                selectedTerm: action.payload.selectedTerm,
            }),
    },
    setInitialState()
);

module.exports = contractEasyLoanTypeCReducer;
module.exports.setInitialState = setInitialState;
